import { Form } from 'factorial-form'

class AttendanceSettingShiftLocationForm extends Form {
  constructor(values: {}) {
    super(values, {
      enable_clock_in_location: 'boolean',
    })
  }
}

export default AttendanceSettingShiftLocationForm
